import styled from 'styled-components';
import Modal from 'react-modal';

import JobOptions from '../InstallationModalCommon/JobOptions';
import AddToCartButton from '../InstallationModalCommon/AddToCartButton';
import DesignSummary from './DesignSummary/DesignSummaryConnector';
import breakpoints, { breakpointsDesktopFirst } from '../../themes/breakpoints';

// const modalPadding = '0 2em 2em 2em';
const modalPadding = '0 0 2px 0';
const buttonPadding = '2em';

export const FlexJobOptions = styled(JobOptions)`
min-height: min-content;
`;

export const FlexAddToCartButtonContainer = styled.div`
  padding: 0 ${buttonPadding} 1.5em ${buttonPadding};

  @media ${breakpointsDesktopFirst.tablet} {
    position: absolute;
    bottom: .5em;
    padding: 0 0;
    width: calc(100% - ${buttonPadding} - ${buttonPadding});
    left: ${buttonPadding};
    right: ${buttonPadding};
}
`;


export const FlexAddToCartButton = styled(AddToCartButton).attrs({ className: 'btn btn-primary' })`
    width: 100%;
`;

export const FlexDesignSummary = styled(DesignSummary)`
min-height: min-content;
flex: 1 0 0%;
`;

export const ModalTitle = styled.div`
  font-size: 1.1rem;
  line-height: 3rem;
  vertical-align: center;
  font-weight: bold;
  text-align: left;
  width:100%;
  border-bottom: 1px solid #E2E2E2;
  padding-left: 2rem;
  display: flex;
  justify-content: space-between;
`;

export const CloseModalButton = styled.div`
    width: 36px;
    height: 36px;
    margin-top: 4px;
    margin-right: 4px;
    cursor: pointer;
    font-weight: 400;
`;

export const FlexProjectDetails = styled.div`
display: flex;
flex-direction: column;
`;

export const FlexModal = styled.div`
display: flex;
flex-direction: column;
flex-wrap: nowrap;
justify-content: space-between;
height: calc(100% - 3rem);
width: 100%;
min-height: min-content;
max-width: 100%;
overflow-y: auto;


@media ${breakpoints.desktopSmall} {
  flex-wrap: wrap;
  ${FlexProjectDetails} {
    order: 1;
    width: 55%;
    max-height: 100%;
    overflow-y: auto;
  }
  ${FlexDesignSummary} {
    order: 2;
    width: 45%;
    flex: 1 0 100%;
  }
}
`;

export const ResponsiveInstallationSummaryModal = styled(Modal)`
position: absolute;
width: 960px;
height: 90vh;
max-height: 80vh;
max-width: 80vw;
background-color: white;
padding: ${modalPadding};
border-radius: 10px;
overflow-y: scroll;

top: 50%;
left: 50%;
transform: translate(-50%, -50%);

@media ${breakpointsDesktopFirst.tablet} {
  padding-bottom: 70px;
}

@media ${breakpoints.desktopSmall} {
  max-height: 90vh;
  min-height: 820px;
}
`;
